@if (isDesktopSize()) {
  <app-nav-deskop
    [menuItems]="menuItems"
    [isLoggedIn]="isLoggedIn()"
  ></app-nav-deskop>
} @else {
  <app-nav-mobile [menuItems]="menuMobileItems"></app-nav-mobile>
}
